var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5.333,
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.625 2.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.333,
    cy: 14,
    r: 12.333,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.333,
    cy: 12.333,
    r: 12.333,
    fill: "#F7F5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M16.31 10.979h-1.683l1.892-9.036c.177-.846-.964-1.308-1.442-.584L7.328 13.092c-.344.52.035 1.208.665 1.208h1.34l-2.619 7.08c-.272.734.689 1.296 1.213.708l8.9-9.984c.391-.438.076-1.125-.516-1.125z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgZmlsbD0iI0U3NDUzNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2IC0xOCkgdHJhbnNsYXRlKDE2IDE4KSI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNS4zMzMiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNiAtMTgpIHRyYW5zbGF0ZSgxNiAxOCkgdHJhbnNsYXRlKDIuNjI1IDIuODc1KSI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTQuMzMzIiBjeT0iMTQiIHI9IjEyLjMzMyIgZmlsbD0iIzBGMTk0MSIvPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEyLjMzMyIgY3k9IjEyLjMzMyIgcj0iMTIuMzMzIiBmaWxsPSIjRjdGNUYwIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGQjUxMSIgZD0iTTE2LjMxIDEwLjk3OWgtMS42ODNsMS44OTItOS4wMzZjLjE3Ny0uODQ2LS45NjQtMS4zMDgtMS40NDItLjU4NEw3LjMyOCAxMy4wOTJjLS4zNDQuNTIuMDM1IDEuMjA4LjY2NSAxLjIwOGgxLjM0bC0yLjYxOSA3LjA4Yy0uMjcyLjczNC42ODkgMS4yOTYgMS4yMTMuNzA4bDguOS05Ljk4NGMuMzkxLS40MzguMDc2LTEuMTI1LS41MTYtMS4xMjV6Ii8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlashIcon as ReactComponent };